import { createSlice } from '@reduxjs/toolkit';
import juratLocalStorage from '../util/local-storage';
import c from '../util/const';
import logger from '../util/logger';

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: {
    isAuthenticated: false,
    token: null,
    preAuthEmail: '',
    deviceGUID: null,
    userRoles: [],
    // False until the user's roles have been fetched after a load or reload.
    rolesResolved: false
  },
  reducers: {
    setToken: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload;
    },

    setUserRoles: (state, action) => {
      state.userRoles = action.payload || [];
      state.rolesResolved = true;
    },

    setFeatures: (state, action) => {
      state.features = action.payload;
    },

    setPreAuthEmail: (state, action) => {
      state.preAuthEmail = action.payload;
    },

    logout: state => {
      state.isAuthenticated = true;
      state.token = null;
      state.userRoles = [];
      state.rolesResolved = false;
    },
    setDeviceGUID: (state, action) => {
      state.deviceGUID = action.payload;
    },
    getToken: (state, action) => {
      return state.token;
    }
  }
});

export const {
  setToken,
  setUserRoles,
  setFeatures,
  setPreAuthEmail,
  logout,
  setDeviceGUID,
  getToken
} = authenticationSlice.actions;

export default authenticationSlice.reducer;
